<div class="modal" tabindex="-1">
    <div class="modal-dialog modal-fullscreen-lg-down modal-xl">
        <div class="modal-content">
            <div class="modal-header flex-column">
                <div class="ms-auto">
                    <button (click)="close()" type="button" class="btn-close" aria-label="Close"></button>
                </div>
                <h3 class="modal-title fw-bold text-center">{{(settings$ | async).competitionTitle}}</h3>
            </div>
            <div class="modal-body p-3 p-lg-5">

                    <!-- <h4 class="text-center"></h4> -->

                    <section class="text-center" [innerHTML]="(settings$ | async).competitionText"></section>

                    <div class="row mt-5">
                        <div class="col-lg-6 offset-lg-3">


                            <form class="contact__form needs-validation" [formGroup]="contactForm" (ngSubmit)="onSubmit()"
                            novalidate>
                                  <div class="contact__form__group mb-34">
                                      <input type="text" class="form-control" formControlName="firstName"
                                             placeholder="First name"
                                             [ngClass]="{ 'is-invalid': field.firstName.touched && field.firstName.errors }"/>
                                      <div *ngIf="field.firstName.hasError && field.firstName.touched"
                                           class="invalid-feedback mb-1">
                                          <ng-container *ngIf="field.firstName.hasError('required')">
                                              Please provide your first name.
                                          </ng-container>
                                          <ng-container *ngIf="field.firstName.hasError('minlength')">
                                              First name needs to be at
                                              least {{ field.firstName.errors.minlength.requiredLength }}
                                              characters long.
                                          </ng-container>
                                      </div>
                                      <input type="text" class="form-control mt-2" formControlName="lastName"
                                             placeholder="Last name"
                                             [ngClass]="{ 'is-invalid': field.lastName.touched && field.lastName.errors }"/>
                                      <div *ngIf="field.lastName.hasError && field.lastName.touched"
                                           class="invalid-feedback mb-1">
                                          <ng-container *ngIf="field.lastName.hasError('required')">
                                              Please provide your last name.
                                          </ng-container>
                                          <ng-container *ngIf="field.lastName.hasError('minlength')">
                                              Last name needs to be at
                                              least {{ field.lastName.errors.minlength.requiredLength }}
                                              characters long.
                                          </ng-container>
                                      </div>
                                  </div>

                                  <div class="contact__form__group mb-34">
                                      <input type="email" class="form-control mt-2" name="email" formControlName="email"
                                             placeholder="Email address"
                                             [ngClass]="{ 'is-invalid': field.email.touched && field.email.errors }"/>
                                      <div *ngIf="field.email.hasError && field.email.touched" class="invalid-feedback mb-1">
                                          <ng-container *ngIf="field.email.hasError('required')">
                                              Please provide your email address.
                                          </ng-container>
                                          <ng-container *ngIf="field.email.hasError('minlength')">
                                              Email address needs to be at
                                              least {{ field.email.errors.minlength.requiredLength }}
                                              characters long.
                                          </ng-container>
                                          <ng-container
                                              *ngIf="field.email.hasError('email') && !field.email.hasError('minlength')">
                                              Please provide a valid email address.
                                          </ng-container>
                                      </div>
                                      <input type="text" class="form-control mt-2" formControlName="phone"
                                             placeholder="Telephone number"
                                             [ngClass]="{ 'is-invalid': field.phone.touched && field.phone.errors }"/>
                                      <div *ngIf="field.phone.hasError && field.phone.touched" class="invalid-feedback mb-1">
                                          <ng-container *ngIf="field.phone.hasError('required')">
                                              Please provide your phone number.
                                          </ng-container>
                                          <ng-container *ngIf="field.phone.hasError('minlength')">
                                              Phone number needs to be at
                                              least {{ field.phone.errors.minlength.requiredLength }}
                                              numbers long.
                                          </ng-container>
                                          <ng-container *ngIf="field.phone.hasError('pattern')">
                                              Please provide a valid phone number (only numbers).
                                          </ng-container>
                                      </div>
                                  </div>

                              <div class="mt-3 text-end">
                                  <button type="submit" class="btn btn-primary">
                                      Submit
                                  </button>
                              </div>
                      </form>




                        </div>
                    </div>
            </div>
        </div>
    </div>
</div>
